export default __webpack_public_path__ + "static/media/79-min.b3228536.jpg";